import { render } from "./Dashboard.vue?vue&type=template&id=5755129f&scoped=true&ts=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=5755129f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3940516335/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5755129f"]])

export default __exports__